<template>
  <loading style="margin-top: -64px"/>
</template>

<script>
  import userUtils from '@/utils/userUtils.js';
  
  export default {
    name: 'Logout',
    components: {  },
    data: function () {
      return {
      }
    },
    mounted: function () {
      var t = this;
      this.$store.state.cookieExpireTime = 0;
      userUtils.logout(t, a => {
        window.location.href = t.$config.get('basePathFiles') + (t.$route.query.redirect && t.$route.query.redirect !== '/logout' ? '?redirect=' + t.$route.query.redirect : '');
      });
    }
  }

</script>